import FingerprintJS from "@fingerprintjs/fingerprintjs";

let fingerprint: string | undefined = undefined;

export function useVisitorFingerprint() {
  const get = async (): Promise<string> => {
    if (fingerprint === undefined) {
      const fpPromise = await FingerprintJS.load();
      const data = await fpPromise.get();
      fingerprint = data.visitorId;
    }

    return fingerprint;
  };

  return {
    get,
  };
}
